module.exports = __webpack_public_path__ + "assets/c18afd66f70382045bb5ab20175bba4e.mp3";